// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.gray {
  color: gray;
}

.silver {
  color: #C3CDE6;
}

.gold {
  color: gold;
}

.brown {
  color: brown;
}

.fbox {
  flex: 1;
  display: flex;
}

.vflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.hflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.shadow-gray {
  border: 1px solid lightgray;
  box-shadow: 2px 2px 5px 1px lightgray;
}

.space-between {
  /* previous syntax */
  -ms-box-pack: justify;
  box-pack: justify;
  /* current syntax */
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.flex-left {
  justify-self: flex-start;
  margin-right: auto;
}

.flex-right {
  justify-self: flex-end;
  margin-left: auto;
}

.right-margin-20 {
  margin-right: 20px;
}

.left-margin-20 {
  margin-left: 20px;
}

.bottom-margin-20 {
  margin-bottom: 20px;
}

.bottom-margin-30 {
  margin-bottom: 30px;
}

.bottom-margin-40 {
  margin-bottom: 40px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-40 {
  margin-top: 40px;
}

.margin-auto {
  margin: auto;
}

.h-margin-auto {
  margin-right: auto;
  margin-left: auto;
}

.v-margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.flex-30 {
  flex: 0 0 30%;
}

.flex-90 {
  flex: 0 0 90%;
}

.padding-right-10 {
  padding-right: 10%;
}

.main {
  /* previous syntax */
  -ms-box-flex: 1;
  box-flex: 1;
  /* current syntax */
  -moz-flex: 1;
  flex: 1;
  height: 100%;
  width: 100%;
  margin: 0;
  overflow-y: auto;
}

.main-header-container {
  margin-bottom: 20px;
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}
.main-header-container .main-header {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
  flex-wrap: wrap;
}
.main-header-container .main-header .main-header-title {
  font-size: 1.25rem;
  flex-basis: 100%;
  font-weight: 500;
}
.main-header-container .main-header .main-header-icon {
  color: rgba(28, 129, 158, 0.8);
  font-size: 28px;
  margin-right: 10px;
  align-self: center;
  text-shadow: 2px 2px lightgray;
}

.main-aside-open {
  padding-right: 320px;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}

.sunken {
  box-shadow: 1px 3px 5px -1px rgba(0, 0, 0, 0.2) inset, 1px 6px 10px 0 rgba(0, 0, 0, 0.14) inset, 1px 1px 18px 0 rgba(0, 0, 0, 0.12) inset;
}

.gray {
  color: gray;
}

.silver {
  color: #C3CDE6;
}

.gold {
  color: gold;
}

.brown {
  color: brown;
}

.fbox {
  flex: 1;
  display: flex;
}

.vflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.hflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.shadow-gray {
  border: 1px solid lightgray;
  box-shadow: 2px 2px 5px 1px lightgray;
}

.space-between {
  /* previous syntax */
  -ms-box-pack: justify;
  box-pack: justify;
  /* current syntax */
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.flex-left {
  justify-self: flex-start;
  margin-right: auto;
}

.flex-right {
  justify-self: flex-end;
  margin-left: auto;
}

.right-margin-20 {
  margin-right: 20px;
}

.left-margin-20 {
  margin-left: 20px;
}

.bottom-margin-20 {
  margin-bottom: 20px;
}

.bottom-margin-30 {
  margin-bottom: 30px;
}

.bottom-margin-40 {
  margin-bottom: 40px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-40 {
  margin-top: 40px;
}

.margin-auto {
  margin: auto;
}

.h-margin-auto {
  margin-right: auto;
  margin-left: auto;
}

.v-margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.flex-30 {
  flex: 0 0 30%;
}

.flex-90 {
  flex: 0 0 90%;
}

.padding-right-10 {
  padding-right: 10%;
}

.modal-dialog.modal-fullscreen-url-viewer-down {
  width: 90vw;
  max-width: none;
  height: 100%;
  margin: auto;
  padding-top: 30px;
}
.modal-dialog.modal-fullscreen-url-viewer-down .modal-body {
  padding: 1rem;
}

.suggestion-html-content > a {
  color: #067272;
  font-weight: 500;
  cursor: auto;
}

@media (min-width: 800px) {
  .modal-dialog {
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
}
.modal-body .h6, .modal-body .h6, .modal-body h5, .modal-body .h5, .modal-body h4, .modal-body .h4, .modal-body h3, .modal-body .h3, .modal-body h2, .modal-body .h2, .modal-body h1, .modal-body .h1 {
  margin-bottom: 1.25rem;
  color: #022B2A;
}

/* The styles above for the modal-body, footer, etc aren't being applied so I tried the ones below and they work */
.modal-body {
  height: 100%;
}

.light-style__logo-container img {
  width: 170px;
  display: flex;
  /* padding: 0px; */
  align-items: center;
  background: none;
  border: 0px;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  margin: 20px;
}

.light-style__floating-form-container {
  width: 350px;
  margin: 20px auto;
  background-color: inherit;
  border-radius: 15px;
  padding: 4px;
}

.light-style__form-group {
  margin-top: 20px;
}
.light-style__form-group label {
  display: block;
  margin-bottom: 10px;
}
.light-style__form-group input {
  min-width: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 1px solid #c4c7cf;
  border-radius: 6px;
  box-sizing: border-box;
  color: #191b23;
  font-size: inherit;
  text-overflow: ellipsis;
  font-family: inherit;
}

.light-style__form-divider {
  position: relative;
  margin-top: 14px;
  margin-bottom: 16px;
  text-align: center;
  border-top: 1px solid #d1d4db;
}
.light-style__form-divider .divider-inner {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
}
.light-style__form-divider .divider-inner .divider-text {
  background-color: #fff;
  padding: 0 25px;
  font-size: 14px;
}

.light-style__quiet-link {
  display: inline-block;
  font-family: inherit;
  color: #006dca;
  line-height: normal;
  position: relative;
  cursor: pointer;
  -webkit-text-decoration: none;
  text-decoration: none;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  outline: 0;
  background: 0 0;
  transition: color 0.15s ease-in-out;
}

.light-style__button_form-submit {
  background-color: rgba(205, 227, 227, 0.8);
  width: 100%;
  border: 0;
  position: relative;
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
}

.light-style__button_third-party-auth {
  background-color: #fff;
  width: 100%;
  border: 1px solid #c4c7cf;
  position: relative;
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}
.light-style__button_third-party-auth img {
  margin-top: -4px;
}

.button_full-width {
  width: 100%;
}

.light-style__cancel-button {
  background-color: #fff;
  border: 1px solid #022B2A;
  color: #022B2A;
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
}

.light-style__confirm-button {
  background-color: #022B2A;
  border: 1px solid #022B2A;
  color: #fff;
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
}

main.light-style__page-container {
  padding: 20px 40px;
  max-width: 1080px;
}
main.light-style__page-container h5, main.light-style__page-container .h5 {
  font-size: 1.625rem;
}
main.light-style__page-container .page-header {
  margin: 0;
}
main.light-style__page-container section {
  margin-bottom: 30px;
}
main.light-style__page-container .section-discription {
  font-size: 1em;
  color: lightslategray;
  margin-bottom: 20px;
}

.light-style__modal-container > * {
  padding: 1rem 2rem;
}
.light-style__modal-container h5, .light-style__modal-container .h5 {
  font-size: 1.625rem;
}
.light-style__modal-container h6 {
  color: #022B2A;
  font-weight: bold;
}
.light-style__modal-container .modal-header {
  display: flex;
  flex-direction: column;
  align-items: normal;
  border-bottom: 1px solid #E5E5E5;
}
.light-style__modal-container .page-header {
  margin: 0;
}
.light-style__modal-container section {
  margin-bottom: 30px;
}
.light-style__modal-container .section-discription {
  font-size: 1em;
  color: lightslategray;
}

.section-divide {
  background: linear-gradient(to left, rgba(0, 0, 0, 0.2) 0px, rgba(0, 0, 0, 0.2) 1px, rgba(0, 0, 0, 0.1) 1px, rgba(0, 0, 0, 0) 100%);
  bottom: 0px;
  left: -3px;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  top: 0px;
  transition-duration: 0.22s;
  transition-property: left, opacity, width;
  transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
  width: 3px;
}

.section-header {
  color: rgb(94, 108, 132);
  vertical-align: middle;
  text-align: initial;
  padding: 4px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}

.card-container:hover {
  box-shadow: var(--ds-shadow-overlay, 0 8px 16px -4px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31));
  transition: box-shadow 0.2s ease 0s;
}

.card-container.card-active {
  box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px lightskyblue);
}

p:first-child, ul:first-child, ol:first-child, dl:first-child, h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child, blockquote:first-child, pre:first-child, form:first-child, table:first-child {
  margin-top: 0;
}

.css-b6ieuv {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}

.css-8ypwyz {
  flex: 1 1 0px;
  min-width: 0px;
  min-height: 100%;
}

.css-m7ep84 {
  max-width: 1280px;
  margin: 16px auto 0px;
}

.css-1120ym1 {
  display: flex;
  margin: 0px auto;
  padding: 0 calc(var(--ds-grid-spacing) / 2);
  position: relative;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 100%;
}

.css-1427chj {
  min-width: calc(99.9999% / var(--ds-columns-num) - var(--ds-grid-spacing));
  margin: 0 calc(var(--ds-grid-spacing) / 2);
  flex: 1 0 auto;
  overflow-wrap: break-word;
  max-width: calc(100% - var(--ds-grid-spacing));
}

.css-1yjvs5a {
  margin-bottom: 32px;
}

.dBTmnX {
  margin: 16px 0px 16px;
}

.irgVLs {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.dCZcE {
  flex: 1 0 auto;
  margin-bottom: 8px;
  max-width: 100%;
  min-width: 0px;
}

.css-x1sij0 {
  display: flex;
  align-items: baseline;
}

.css-9wkoav {
  font-size: 1.42857em;
  font-style: inherit;
  line-height: 1.2;
  color: var(--ds-text, var(--ds-text, #172B4D));
  font-weight: 500;
  letter-spacing: -0.008em;
  margin-top: 28px;
}

.css-4lry5y {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 12px;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  border: 1px solid rgb(235, 236, 240);
  box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13));
}

.css-1cjmyt {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
  width: 16px;
  height: 16px;
}

.css-1cjmyt > svg {
  overflow: hidden;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  color: var(--icon-primary-color);
  fill: var(--icon-secondary-color);
  vertical-align: bottom;
}

.css-13ep12v {
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1 1 100%;
}

.css-lvtuw9 {
  display: flex;
  height: 32px;
  align-items: center;
  justify-content: space-between;
}

.action-list-item .eh2v9p60 {
  outline: none;
  position: static;
}

.action-list-item a {
  position: relative;
  z-index: 1;
}

.css-84l4l4 {
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  color: black;
  overflow: hidden;
  max-width: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-7tfc0v {
  margin-top: 32px;
  margin-bottom: 16px;
}

.css-4l544k {
  padding: 40px 0px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 2px solid rgb(223, 225, 230);
  border-bottom: 2px solid rgb(223, 225, 230);
}

.css-guw80f {
  height: 32px;
  width: 32px;
  align-items: stretch;
  background-color: var(--ds-surface-overlay, #FFFFFF);
  border-radius: 3px;
  box-sizing: content-box;
  cursor: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;
  overflow: hidden;
  position: static;
  transform: translateZ(0px);
  transition: transform 200ms ease 0s, opacity 200ms ease 0s;
  box-shadow: 0 0 0 2px var(--ds-surface-overlay, #FFFFFF);
  border: none;
  margin: 2px;
  padding: var(--ds-scale-0, 0px);
  font-size: inherit;
  font-family: inherit;
}

.css-38fxp4 {
  position: relative;
  z-index: 1;
}

.css-38fxp4 button {
  padding: 0px 4px;
}

.css-cbn15f {
  align-items: baseline;
  border-width: 0px;
  box-sizing: border-box;
  display: inline-flex;
  font-size: inherit;
  font-style: normal;
  font-weight: 500;
  max-width: 100%;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  background: none;
  border-radius: 3px;
  cursor: default;
  height: 2.28571em;
  line-height: 2.28571em;
  padding: 0px 8px;
  transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  vertical-align: middle;
  width: auto;
  outline: none !important;
  color: rgb(0, 82, 204) !important;
}

.css-noix33 {
  align-self: center;
  display: flex;
  flex-shrink: 0;
  line-height: 0;
  font-size: 0px;
  -webkit-user-select: none;
          user-select: none;
  margin: 0px -2px;
  transition: opacity 0.3s ease 0s;
  opacity: 1;
}

.css-1wits42 {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
  width: 16px;
  height: 16px;
}

.css-1wits42 > svg {
  overflow: hidden;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  color: var(--icon-primary-color);
  fill: var(--icon-secondary-color);
  vertical-align: bottom;
}

img, svg {
  vertical-align: middle;
}

.css-k008qs {
  display: flex;
}

.action-list-item {
  display: block;
  position: relative;
  box-sizing: border-box;
  min-width: 156px;
  width: 100%;
  max-width: 208px;
  box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13));
  border-radius: 3px;
  cursor: pointer;
}

.action-list-item + .action-list-item {
  margin-left: 8px;
}

.css-19midj6 {
  padding: 16px;
}

.css-sdn32z {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
}

.jCnDPm {
  flex: 0 0 auto;
  margin-bottom: 8px;
  margin-left: auto;
  max-width: 100%;
  padding-left: 32px;
  white-space: nowrap;
}

.css-14691fi {
  align-items: baseline;
  border-width: 0px;
  box-sizing: border-box;
  display: inline-flex;
  font-size: inherit;
  font-style: normal;
  max-width: 100%;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  background: none;
  border-radius: 3px;
  cursor: default;
  height: auto;
  line-height: inherit;
  padding: 0px;
  transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  vertical-align: baseline;
  width: auto;
  font-weight: 400;
  outline: none !important;
  color: rgb(0, 82, 204) !important;
}

.css-j8fq0c {
  align-self: center;
  display: inline-flex;
  flex-wrap: nowrap;
  max-width: 100%;
  position: relative;
}

.css-eaycls {
  align-items: center;
  align-self: center;
  flex: 1 1 auto;
  margin: 0px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: opacity 0.3s ease 0s;
  opacity: 1;
}

.css-8rg1di {
  display: inline-block;
}

.css-8rg1di::before {
  content: "•";
  width: 16px;
  display: inline-block;
  text-align: center;
  color: rgb(0, 82, 204);
}

p, ul, ol, dl, h1, h2, h3, h4, h5, h6, blockquote, pre, form, table {
  margin: 12px 0 0;
}

.css-i9qcsw {
  border: 0px !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0px !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
}

.snapshot-container {
  padding: 40px 0px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  border-top: 2px solid rgb(223, 225, 230);
  border-bottom: 2px solid rgb(223, 225, 230);
}

.stat-item {
  margin-bottom: 3px;
  font-size: 0.8rem;
  font-weight: 600;
}

.snapshot-card-list-container {
  display: flex;
  justify-content: center;
}
.snapshot-card-list-container .snapshop-container-area {
  border: 1px solid lightgray;
  border-radius: 20px;
  width: 50%;
}
.snapshot-card-list-container .snapshot-card-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-group-label {
  border-bottom: 1px solid lightgray;
  width: 60%;
  font-size: 0.8rem;
  margin-bottom: 3px;
}
.snapshot-card-list-container .snapshot-card-list .t1 {
  margin-right: 10px;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card {
  display: block;
  text-align: center;
  margin: 0px 15px 10px 0px;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-top {
  font-size: 0.8rem;
  font-weight: 500;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-highlight.gray {
  border-bottom: 2px solid gray;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-highlight.silver {
  border-bottom: 2px solid #C3CDE6;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-highlight.gold {
  border-bottom: 2px solid gold;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-center {
  font-size: 1.5rem;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-bottom {
  font-size: 14px;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-next {
  font-size: 12px;
  color: deepskyblue;
}

.score-metrix-title {
  color: rgb(94, 108, 132);
  font-weight: bold;
}

.score-metric-activity {
  margin: 15px 0px 5px 0px;
  font-size: 1.5rem;
  text-align: center;
  color: green;
}

.score-stat-container {
  justify-content: space-between;
  margin-top: 20px;
}

.snapshot-highlight.gray {
  border-bottom: 2px solid gray;
}
.snapshot-highlight.silver {
  border-bottom: 2px solid #C3CDE6;
}
.snapshot-highlight.gold {
  border-bottom: 2px solid gold;
}

.css-1yjvs5a {
  margin-bottom: 32px;
}

.css-1yq88hf {
  table-layout: fixed;
  width: 100%;
  pointer-events: auto;
  margin-top: 0px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead, tbody, tfoot {
  border-bottom: 2px solid #dfe1e6;
}

td, th {
  text-align: left;
  border: none;
  padding: 4px 8px;
}

.inbound-header-referrer:first-of-type {
  padding-left: 0px;
}

td:first-child, th:first-child {
  padding-left: 0;
}

td:last-child, th:last-child {
  padding-right: 0;
}

.table-row-data {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  box-sizing: border-box;
  text-align: initial;
  max-width: 0px;
}

.inbound-header-referrer {
  color: rgb(94, 108, 132);
  vertical-align: middle;
  text-align: initial;
  padding: 4px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-wwul1v {
  color: rgb(94, 108, 132);
  vertical-align: middle;
  text-align: initial;
  padding: 4px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 104px;
}

.css-1v02n3u {
  color: rgb(94, 108, 132);
  vertical-align: middle;
  text-align: initial;
  padding: 4px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-i7vie8 {
  color: rgb(94, 108, 132);
  vertical-align: middle;
  text-align: center;
  padding: 4px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-jfpkqj {
  background-color: initial;
}

.article-data-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  box-sizing: border-box;
  text-align: initial;
  max-width: 0px;
}

.article-data-trust {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  box-sizing: border-box;
  text-align: initial;
  max-width: 0px;
  width: 104px;
}

.article-data-feedback {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  box-sizing: border-box;
  text-align: initial;
  max-width: 0px;
}

.article-data-dismiss-menu {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  box-sizing: border-box;
  text-align: initial;
  max-width: 0px;
}

.css-159i7d {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.css-bn30qb {
  display: flex;
  align-items: center;
  overflow: hidden;
  height: 100%;
  padding-right: 4px;
}

.row-data-tag-container {
  box-sizing: border-box;
  -webkit-appearance: none;
          appearance: none;
  border: none;
  display: inline-flex;
  position: static;
  padding-inline: var(--ds-space-050, 4px);
  background-color: var(--ds-background-information, #DEEBFF);
  border-radius: 3px;
}

.row-data-tag {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  color: var(--ds-text-information, #0052CC);
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
}

.css-2iyn1h, .css-2iyn1h:hover, .css-2iyn1h:focus {
  color: rgb(23, 43, 77);
}

.css-2iyn1h {
  overflow: hidden;
  display: flex;
  align-items: center;
}

.css-70qvj9 {
  display: flex;
  align-items: center;
}

.css-1wm6frj {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 20px;
}

.css-i6bazn {
  overflow: hidden;
}

.css-4y2086 {
  overflow: hidden;
  max-width: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-1nkownu {
  padding-right: 8px;
  color: rgb(107, 119, 140);
  white-space: nowrap;
}

.css-7clv8h {
  height: 32px;
  width: 32px;
  align-items: stretch;
  background-color: var(--ds-surface-overlay, #FFFFFF);
  border-radius: 50%;
  box-sizing: content-box;
  cursor: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;
  overflow: hidden;
  position: static;
  transform: translateZ(0px);
  transition: transform 200ms ease 0s, opacity 200ms ease 0s;
  box-shadow: 0 0 0 2px var(--ds-surface-overlay, #FFFFFF);
  border: none;
  margin: 2px;
  padding: var(--ds-scale-0, 0px);
  font-size: inherit;
  font-family: inherit;
}

.css-7clv8h::after {
  background-color: transparent;
  inset: 0px;
  border-radius: 50%;
  content: " ";
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 200ms ease 0s;
  width: 100%;
}

.cLrmQm {
  display: inline-flex;
}

.eteVrT {
  display: inline-flex;
  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
}

.css-fbv3aj, .css-fbv3aj:hover, .css-fbv3aj:active, .css-fbv3aj:focus, .css-fbv3aj:visited, .css-fbv3aj:disabled, .css-fbv3aj[disabled] {
  align-items: baseline;
  border-width: 0px;
  border-radius: 3px;
  box-sizing: border-box;
  display: inline-flex;
  font-size: inherit;
  font-style: normal;
  font-family: inherit;
  font-weight: 500;
  max-width: 100%;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  white-space: nowrap;
  background: none;
  cursor: pointer;
  height: 2.28571em;
  line-height: 2.28571em;
  padding: 0px 2px;
  vertical-align: middle;
  width: auto;
  justify-content: center;
  outline: none;
  color: rgb(66, 82, 110) !important;
}

.css-1ujqpe8 {
  transition: opacity 0.3s ease 0s;
  opacity: 1;
  align-self: center;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  line-height: 0;
  font-size: 0px;
  -webkit-user-select: none;
          user-select: none;
  margin: 0px 2px;
}

.css-snhnyn {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
}

.css-snhnyn > svg {
  overflow: hidden;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  color: var(--icon-primary-color);
  fill: var(--icon-secondary-color);
  vertical-align: bottom;
}

.action-list-item-icon {
  color: lightskyblue;
}`, "",{"version":3,"sources":["webpack://./src/app/views/landing/landing.component.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/mixins.scss","webpack://./src/scss/main.scss","webpack://./src/scss/overrides.scss","webpack://./src/scss/light-style.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACUhB;EACI,WAAA;ADRJ;;ACUA;EACI,cAAA;ADPJ;;ACSA;EACI,WAAA;ADNJ;;ACQA;EACI,YAAA;ADLJ;;AEmFA;EACE,OAAA;EACA,aAAA;AFhFF;;AEmFA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,2BAAA;EAEK,sBAAA;AFjFV;;AEoFA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,wBAAA;EAEK,mBAAA;AFlFV;;AEqFA;EAEI,mBAAA;EACA,uBAAA;AFnFJ;;AEsFA;EACI,2BAAA;EACA,qCAAA;AFnFJ;;AEsFA;EACI,oBAAA;EAGI,qBAAA;EACI,iBAAA;EAER,mBAAA;EAEI,mCAAA;EACA,kCAAA;EACI,8BAAA;AFpFZ;;AEuFA;EACI,wBAAA;EACA,kBAAA;AFpFJ;;AEuFA;EACI,sBAAA;EACA,iBAAA;AFpFJ;;AEuFA;EACI,kBAAA;AFpFJ;;AEuFA;EACI,iBAAA;AFpFJ;;AEuFA;EACI,mBAAA;AFpFJ;;AEuFA;EACI,mBAAA;AFpFJ;;AEuFA;EACI,mBAAA;AFpFJ;;AEuFA;EACI,gBAAA;AFpFJ;;AEuFA;EACI,gBAAA;AFpFJ;;AEuFA;EACI,YAAA;AFpFJ;;AEsFA;EACI,kBAAA;EACA,iBAAA;AFnFJ;;AEqFA;EACI,gBAAA;EACA,mBAAA;AFlFJ;;AEqFA;EACI,aAAA;AFlFJ;;AEqFA;EACI,aAAA;AFlFJ;;AEqFA;EACI,kBAAA;AFlFJ;;AG/HA;EACI,oBAAA;EAGI,eAAA;EACI,WAAA;EAER,mBAAA;EAEI,YAAA;EAEI,OAAA;EAER,YAAA;EACA,WAAA;EACA,SAAA;EAGA,gBAAA;AH8HJ;;AG3HA;EAEI,mBAAA;EDRA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGI,wBAAA;EAEI,mBAAA;AFqIZ;AGlII;EDZA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGI,wBAAA;EAEI,mBAAA;ECKJ,eAAA;AH4IR;AG3IQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AH6IZ;AG1IQ;EACI,8BFrCG;EEsCH,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;AH4IZ;;AGvIA;EACI,oBAAA;AH0IJ;;AGvIA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AH0IJ;;AGnIA;EACI,yIACI;AHqIR;;AC9LA;EACI,WAAA;ADiMJ;;AC/LA;EACI,cAAA;ADkMJ;;AChMA;EACI,WAAA;ADmMJ;;ACjMA;EACI,YAAA;ADoMJ;;AEtHA;EACE,OAAA;EACA,aAAA;AFyHF;;AEtHA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,2BAAA;EAEK,sBAAA;AFwHV;;AErHA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,wBAAA;EAEK,mBAAA;AFuHV;;AEpHA;EAEI,mBAAA;EACA,uBAAA;AFsHJ;;AEnHA;EACI,2BAAA;EACA,qCAAA;AFsHJ;;AEnHA;EACI,oBAAA;EAGI,qBAAA;EACI,iBAAA;EAER,mBAAA;EAEI,mCAAA;EACA,kCAAA;EACI,8BAAA;AFqHZ;;AElHA;EACI,wBAAA;EACA,kBAAA;AFqHJ;;AElHA;EACI,sBAAA;EACA,iBAAA;AFqHJ;;AElHA;EACI,kBAAA;AFqHJ;;AElHA;EACI,iBAAA;AFqHJ;;AElHA;EACI,mBAAA;AFqHJ;;AElHA;EACI,mBAAA;AFqHJ;;AElHA;EACI,mBAAA;AFqHJ;;AElHA;EACI,gBAAA;AFqHJ;;AElHA;EACI,gBAAA;AFqHJ;;AElHA;EACI,YAAA;AFqHJ;;AEnHA;EACI,kBAAA;EACA,iBAAA;AFsHJ;;AEpHA;EACI,gBAAA;EACA,mBAAA;AFuHJ;;AEpHA;EACI,aAAA;AFuHJ;;AEpHA;EACI,aAAA;AFuHJ;;AEpHA;EACI,kBAAA;AFuHJ;;AIjUA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AJoUJ;AIlUI;EACE,aAAA;AJoUN;;AI3TA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AJ8TF;;AIrTA;EAEE;IACE,2BAAA;IAAA,sBAAA;EJuTF;AACF;AIhTE;EACE,sBAAA;EACA,cAAA;AJkTJ;;AI9OE,kHAAA;AACA;EACE,YAAA;AJiPJ;;AK1WA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AL6WJ;;AK1WA;EACI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AL6WJ;;AK1WA;EACI,gBAAA;AL6WJ;AK3WI;EACI,cAAA;EACA,mBAAA;AL6WR;AK1WI;EAKI,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;ALwWR;;AKpWA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;ALuWJ;AKtWI;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;ALwWR;AKvWQ;EACI,sBAAA;EACA,eAAA;EACA,eAAA;ALyWZ;;AKjWA;EACI,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;EACA,eAAA;EACA,mCAAA;ALoWJ;;AK9VA;EACI,0CAAA;EACA,WAAA;EACA,SAAA;EAEA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;ALgWJ;;AK7VA;EACI,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ALgWJ;AK9VI;EACI,gBAAA;ALgWR;;AK5VA;EACI,WAAA;AL+VJ;;AK5VA;EACI,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AL+VJ;;AK5VA;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AL+VJ;;AKzVA;EAEI,kBAAA;EACA,iBAAA;AL2VJ;AKxVI;EACI,mBAAA;AL0VR;AKvVI;EACI,SAAA;ALyVR;AKtVI;EACI,mBAAA;ALwVR;AKrVI;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;ALuVR;;AKlVI;EACI,kBAAA;ALqVR;AKlVI;EACI,mBAAA;ALoVR;AKjVI;EACI,cAAA;EACA,iBAAA;ALmVR;AKhVI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;ALkVR;AK/UI;EACI,SAAA;ALiVR;AK9UI;EACI,mBAAA;ALgVR;AK7UI;EACI,cAAA;EACA,qBAAA;AL+UR;;AA3hBA;EACI,mIAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,0BAAA;EACA,yCAAA;EACA,sDAAA;EACA,UAAA;AA8hBJ;;AA3hBA;EACI,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA8hBJ;;AA3hBA;EACI,0GAAA;EACA,mCAAA;AA8hBJ;;AA3hBA;EACI,8FAAA;AA8hBJ;;AArhBA;EACI,aAAA;AAwhBJ;;AAthBA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AAyhBJ;;AAvhBA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;AA0hBJ;;AAxhBA;EACI,iBAAA;EACA,qBAAA;AA2hBJ;;AAzhBA;EACI,aAAA;EACA,gBAAA;EACA,2CAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AA4hBJ;;AA1hBA;EACI,0EAAA;EACA,0CAAA;EAEA,cAAA;EACA,yBAAA;EACA,8CAAA;AA6hBJ;;AA3hBA;EACI,mBAAA;AA8hBJ;;AA5hBA;EACI,qBAAA;AA+hBJ;;AA7hBA;EACI,uBAAA;EACA,aAAA;EACA,eAAA;AAgiBJ;;AA9hBA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAiiBJ;;AA/hBA;EACI,aAAA;EAEA,qBAAA;AAkiBJ;;AAhiBA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AAmiBJ;;AAhiBA;EACI,aAAA;EAEA,uBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,uGAAA;AAmiBJ;;AAjiBA;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAoiBJ;;AAliBA;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;AAqiBJ;;AAniBA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAsiBJ;;AApiBA;EACI,aAAA;EACA,YAAA;EAEA,mBAAA;EAEA,8BAAA;AAuiBJ;;AAriBA;EACI,aAAA;EACA,gBAAA;AAwiBJ;;AAtiBA;EACI,kBAAA;EACA,UAAA;AAyiBJ;;AAviBA;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AA0iBJ;;AAxiBA;EACI,gBAAA;EACA,mBAAA;AA2iBJ;;AAziBA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,wCAAA;EACA,2CAAA;AA4iBJ;;AA1iBA;EACI,YAAA;EACA,WAAA;EAEA,oBAAA;EACA,oDAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EAEA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0DAAA;EACA,wDAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;AA6iBJ;;AA1iBA;EACI,kBAAA;EACA,UAAA;AA6iBJ;;AA1iBA;EACI,gBAAA;AA6iBJ;;AA3iBA;EAEI,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iGAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,iCAAA;AA8iBJ;;AA5iBA;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,UAAA;AA+iBJ;;AA7iBA;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAgjBJ;;AA9iBA;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;AAijBJ;;AA/iBA;EACI,sBAAA;AAkjBJ;;AAhjBA;EACI,aAAA;AAmjBJ;;AAjjBA;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EAEA,uGAAA;EACA,kBAAA;EACA,eAAA;AAmjBJ;;AAjjBA;EACI,gBAAA;AAojBJ;;AAljBA;EACI,aAAA;AAqjBJ;;AAnjBA;EACI,aAAA;EAEA,yBAAA;EAEA,qBAAA;AAsjBJ;;AApjBA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAujBJ;;AArjBA;EAEI,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,iGAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,iCAAA;AAwjBJ;;AAtjBA;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAyjBJ;;AAvjBA;EAEI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,UAAA;AA0jBJ;;AAxjBA;EACI,qBAAA;AA2jBJ;;AAzjBA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;AA4jBJ;;AA1jBA;EACI,gBAAA;AA6jBJ;;AA3jBA;EACI,sBAAA;EACA,yCAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,8BAAA;AA8jBJ;;AA3jBA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,wCAAA;EACA,2CAAA;AA8jBJ;;AA3jBA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AA8jBJ;;AA3jBA;EAGI,aAAA;EACA,uBAAA;AA4jBJ;AAljBI;EACI,2BAAA;EACA,mBAAA;EACA,UAAA;AAojBR;AAjjBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAmjBR;AA/iBQ;EACI,kCAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAijBZ;AA9iBQ;EACI,kBAAA;AAgjBZ;AA7iBQ;EAII,cAAA;EACA,kBAAA;EAEA,yBAAA;AA2iBZ;AAtiBY;EACI,iBAAA;EACA,gBAAA;AAwiBhB;AApiBgB;EACI,6BAAA;AAsiBpB;AAniBgB;EACI,gCAAA;AAqiBpB;AAliBgB;EACI,6BAAA;AAoiBpB;AAhiBY;EAEI,iBAAA;AAiiBhB;AA7hBY;EACI,eAAA;AA+hBhB;AA5hBY;EACI,eAAA;EACA,kBAAA;AA8hBhB;;AAvhBA;EACI,wBAAA;EACA,iBAAA;AA0hBJ;;AAvhBA;EACI,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AA0hBJ;;AAvhBA;EACI,8BAAA;EACA,gBAAA;AA0hBJ;;AAthBI;EACI,6BAAA;AAyhBR;AAthBI;EACI,gCAAA;AAwhBR;AArhBI;EACI,6BAAA;AAuhBR;;AAlhBA;EACI,mBAAA;AAqhBJ;;AAnhBA;EACI,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;AAshBJ;;AAphBA;EACI,yBAAA;EACA,WAAA;AAuhBJ;;AArhBA;EACI,gCAAA;AAwhBJ;;AAthBA;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;AAyhBJ;;AAvhBA;EACI,iBAAA;AA0hBJ;;AAxhBA;EACI,eAAA;AA2hBJ;;AAzhBA;EACI,gBAAA;AA4hBJ;;AA/gBA;EATI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AA4hBJ;;AArhBA;EACI,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwhBJ;;AAthBA;EACI,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAyhBJ;;AAvhBA;EACI,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA0hBJ;;AAxhBA;EACI,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2hBJ;;AAzhBA;EACI,yBAAA;AA4hBJ;;AA1hBA;EArDI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAmlBJ;;AAjiBA;EAxDI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EAoDA,YAAA;AA0iBJ;;AAxiBA;EA5DI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAwmBJ;;AA/iBA;EA/DI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAknBJ;;AAtjBA;EACI,aAAA;EAEA,mBAAA;EAEA,8BAAA;EACA,YAAA;AAyjBJ;;AAvjBA;EACI,aAAA;EAEA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AA0jBJ;;AAxjBA;EACI,sBAAA;EACA,wBAAA;UAAA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,wCAAA;EACA,2DAAA;EACA,kBAAA;AA2jBJ;;AAzjBA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,2IAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AA4jBJ;;AA1jBA;EACI,sBAAA;AA6jBJ;;AA3jBA;EACI,gBAAA;EACA,aAAA;EAEA,mBAAA;AA8jBJ;;AA5jBA;EACI,aAAA;EAEA,mBAAA;AA+jBJ;;AA7jBA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;AA+jBJ;;AA7jBA;EACI,gBAAA;AAgkBJ;;AA9jBA;EACI,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAikBJ;;AA/jBA;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;AAkkBJ;;AAhkBA;EACI,YAAA;EACA,WAAA;EAEA,oBAAA;EACA,oDAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EAEA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0DAAA;EACA,wDAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;AAmkBJ;;AAjkBA;EACI,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;AAokBJ;;AAlkBA;EACI,oBAAA;AAqkBJ;;AAnkBA;EACI,oBAAA;EACA,oEAAA;AAskBJ;;AApkBA;EAEI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iGAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EAEA,uBAAA;EACA,aAAA;EACA,kCAAA;AAukBJ;;AArkBA;EACI,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EAEA,YAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AAwkBJ;;AAtkBA;EACI,qBAAA;EACA,cAAA;EACA,cAAA;AAykBJ;;AAvkBA;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;AA0kBJ;;AAvkBA;EACI,mBAAA;AA0kBJ","sourcesContent":["@import '../../../scss/index.scss';\n\n.section-divide {\n    background: linear-gradient(to left, rgba(0, 0, 0, 0.2) 0px, rgba(0, 0, 0, 0.2) 1px, rgba(0, 0, 0, 0.1) 1px, rgba(0, 0, 0, 0) 100%);\n    bottom: 0px;\n    left: -3px;\n    opacity: 0.5;\n    pointer-events: none;\n    position: absolute;\n    top: 0px;\n    transition-duration: 0.22s;\n    transition-property: left, opacity, width;\n    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);\n    width: 3px;\n}\n\n.section-header {\n    color: rgb(94, 108, 132);\n    vertical-align: middle;\n    text-align: initial;\n    padding: 4px 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-weight: bold;\n}\n\n.card-container:hover {\n    box-shadow: var(--ds-shadow-overlay,0 8px 16px -4px rgba(9,30,66,0.25),0 0 1px rgba(9,30,66,0.31));\n    transition: box-shadow 0.2s ease 0s;\n}\n\n.card-container.card-active {\n    box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px lightskyblue);\n}\n\n// .landing-container {\n//     flex: 1 1 auto;\n//     margin-left: 0px;\n//     margin-top: 56px;\n//     width: 0px;\n// }\np:first-child, ul:first-child, ol:first-child, dl:first-child, h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child, blockquote:first-child, pre:first-child, form:first-child, table:first-child {\n    margin-top: 0;\n}\n.css-b6ieuv {\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n}\n.css-8ypwyz {\n    flex: 1 1 0px;\n    min-width: 0px;\n    min-height: 100%;\n}\n.css-m7ep84 {\n    max-width: 1280px;\n    margin: 16px auto 0px;\n}\n.css-1120ym1 {\n    display: flex;\n    margin: 0px auto;\n    padding: 0 calc(var(--ds-grid-spacing) / 2);\n    position: relative;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    max-width: 100%;\n}\n.css-1427chj {\n    min-width: calc((99.9999% / var(--ds-columns-num)) - var(--ds-grid-spacing));\n    margin: 0 calc(var(--ds-grid-spacing) / 2);\n    -webkit-box-flex: 1;\n    flex: 1 0 auto;\n    overflow-wrap: break-word;\n    max-width: calc(100% - var(--ds-grid-spacing));\n}\n.css-1yjvs5a {\n    margin-bottom: 32px;\n}\n.dBTmnX {\n    margin: 16px 0px 16px;\n}\n.irgVLs {\n    align-items: flex-start;\n    display: flex;\n    flex-wrap: wrap;\n}\n.dCZcE {\n    flex: 1 0 auto;\n    margin-bottom: 8px;\n    max-width: 100%;\n    min-width: 0px;\n}\n.css-x1sij0 {\n    display: flex;\n    -webkit-box-align: baseline;\n    align-items: baseline;\n}\n.css-9wkoav {\n    font-size: 1.42857em;\n    font-style: inherit;\n    line-height: 1.2;\n    color: var(--ds-text,var(--ds-text,#172B4D));\n    font-weight: 500;\n    letter-spacing: -0.008em;\n    margin-top: 28px;\n    //margin-top: 0;\n}\n.css-4lry5y {\n    display: flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    margin-left: 12px;\n    border-radius: 50%;\n    height: 18px;\n    width: 18px;\n    border: 1px solid rgb(235, 236, 240);\n    box-shadow: var(--ds-shadow-raised,0 1px 1px rgba(9,30,66,0.25),0 0 1px 1px rgba(9,30,66,0.13));\n}\n.css-1cjmyt {\n    display: inline-block;\n    flex-shrink: 0;\n    line-height: 1;\n    width: 16px;\n    height: 16px;\n}\n.css-1cjmyt > svg {\n    overflow: hidden;\n    pointer-events: none;\n    max-width: 100%;\n    max-height: 100%;\n    color: var(--icon-primary-color);\n    fill: var(--icon-secondary-color);\n    vertical-align: bottom;\n}\n.css-13ep12v {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex: 1 1 100%;\n}\n.css-lvtuw9 {\n    display: flex;\n    height: 32px;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n}\n.action-list-item .eh2v9p60 {\n    outline: none;\n    position: static;\n}\n.action-list-item a {\n    position: relative;\n    z-index: 1;\n}\n.css-84l4l4 {\n    font-weight: 500;\n    font-size: 14px;\n    text-decoration: none;\n    color: black;\n    overflow: hidden;\n    max-width: inherit;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.css-7tfc0v {\n    margin-top: 32px;\n    margin-bottom: 16px;\n}\n.css-4l544k {\n    padding: 40px 0px;\n    margin-bottom: 32px;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    border-top: 2px solid rgb(223, 225, 230);\n    border-bottom: 2px solid rgb(223, 225, 230);\n}\n.css-guw80f {\n    height: 32px;\n    width: 32px;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n    background-color: var(--ds-surface-overlay, #FFFFFF);\n    border-radius: 3px;\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0px);\n    transition: transform 200ms ease 0s, opacity 200ms ease 0s;\n    box-shadow: 0 0 0 2px var(--ds-surface-overlay, #FFFFFF);\n    border: none;\n    margin: 2px;\n    padding: var(--ds-scale-0, 0px);\n    font-size: inherit;\n    font-family: inherit;\n}\n\n.css-38fxp4 {\n    position: relative;\n    z-index: 1;\n\n}\n.css-38fxp4 button {\n    padding: 0px 4px;\n}\n.css-cbn15f {\n    -webkit-box-align: baseline;\n    align-items: baseline;\n    border-width: 0px;\n    box-sizing: border-box;\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: 500;\n    max-width: 100%;\n    text-align: center;\n    text-decoration: none;\n    white-space: nowrap;\n    background: none;\n    border-radius: 3px;\n    cursor: default;\n    height: 2.28571em;\n    line-height: 2.28571em;\n    padding: 0px 8px;\n    transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;\n    vertical-align: middle;\n    width: auto;\n    outline: none !important;\n    color: rgb(0, 82, 204) !important;\n}\n.css-noix33 {\n    align-self: center;\n    display: flex;\n    flex-shrink: 0;\n    line-height: 0;\n    font-size: 0px;\n    user-select: none;\n    margin: 0px -2px;\n    transition: opacity 0.3s ease 0s;\n    opacity: 1;\n}\n.css-1wits42 {\n    display: inline-block;\n    flex-shrink: 0;\n    line-height: 1;\n    width: 16px;\n    height: 16px;\n}\n.css-1wits42 > svg {\n    overflow: hidden;\n    pointer-events: none;\n    max-width: 100%;\n    max-height: 100%;\n    color: var(--icon-primary-color);\n    fill: var(--icon-secondary-color);\n    vertical-align: bottom;\n}\nimg, svg {\n    vertical-align: middle;\n}\n.css-k008qs {\n    display: flex;\n}\n.action-list-item {\n    display: block;\n    position: relative;\n    box-sizing: border-box;\n    min-width: 156px;\n    width: 100%;\n    max-width: 208px;\n    //background-image: linear-gradient(rgb(244, 245, 247) 33%, transparent 33%);\n    box-shadow: var(--ds-shadow-raised,0 1px 1px rgba(9,30,66,0.25),0 0 1px 1px rgba(9,30,66,0.13));\n    border-radius: 3px;\n    cursor: pointer;\n}\n.action-list-item + .action-list-item {\n    margin-left: 8px;\n}\n.css-19midj6 {\n    padding: 16px;\n}\n.css-sdn32z {\n    display: flex;\n    -webkit-box-pack: end;\n    justify-content: flex-end;\n    -webkit-box-align: baseline;\n    align-items: baseline;\n}\n.jCnDPm {\n    flex: 0 0 auto;\n    margin-bottom: 8px;\n    margin-left: auto;\n    max-width: 100%;\n    padding-left: 32px;\n    white-space: nowrap;\n}\n.css-14691fi {\n    -webkit-box-align: baseline;\n    align-items: baseline;\n    border-width: 0px;\n    box-sizing: border-box;\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    max-width: 100%;\n    text-align: center;\n    text-decoration: none;\n    white-space: nowrap;\n    background: none;\n    border-radius: 3px;\n    cursor: default;\n    height: auto;\n    line-height: inherit;\n    padding: 0px;\n    transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;\n    vertical-align: baseline;\n    width: auto;\n    font-weight: 400;\n    outline: none !important;\n    color: rgb(0, 82, 204) !important;\n}\n.css-j8fq0c {\n    align-self: center;\n    display: inline-flex;\n    flex-wrap: nowrap;\n    max-width: 100%;\n    position: relative;\n}\n.css-eaycls {\n    -webkit-box-align: center;\n    align-items: center;\n    align-self: center;\n    flex: 1 1 auto;\n    margin: 0px;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    transition: opacity 0.3s ease 0s;\n    opacity: 1;\n}\n.css-8rg1di {\n    display: inline-block;\n}\n.css-8rg1di::before {\n    content: \"•\";\n    width: 16px;\n    display: inline-block;\n    text-align: center;\n    color: rgb(0, 82, 204);\n}\np, ul, ol, dl, h1, h2, h3, h4, h5, h6, blockquote, pre, form, table {\n    margin: 12px 0 0;\n}\n.css-i9qcsw {\n    border: 0px !important;\n    clip: rect(1px, 1px, 1px, 1px) !important;\n    height: 1px !important;\n    overflow: hidden !important;\n    padding: 0px !important;\n    position: absolute !important;\n    width: 1px !important;\n    white-space: nowrap !important;\n}\n\n.snapshot-container {\n    padding: 40px 0px;\n    margin-bottom: 32px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    border-top: 2px solid rgb(223, 225, 230);\n    border-bottom: 2px solid rgb(223, 225, 230);\n}\n\n.stat-item {\n    margin-bottom: 3px;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.snapshot-card-list-container {\n    //border-bottom: 1px solid lightgrey;\n    // padding: 22px;\n    display: flex;\n    justify-content: center;\n\n    h4 {\n        \n    }\n\n    .snapshot-card-list-header {\n\n    }\n\n    .snapshop-container-area {\n        border: 1px solid lightgray;\n        border-radius: 20px;\n        width: 50%;\n    }\n\n    .snapshot-card-list {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        //margin: 10px 0px;\n        \n\n        .snapshot-group-label {\n            border-bottom: 1px solid lightgray;\n            width: 60%;\n            font-size: 0.8rem;\n            margin-bottom: 3px;\n        }\n\n        .t1 {\n            margin-right: 10px;\n        }\n\n        .snapshot-card {\n            //-webkit-box-shadow:0 0 10px rgba(0, 0, 0, 0.5);\n            //-moz-box-shadow:0 0 10px rgba(0, 0, 0, 0.5);\n            //box-shadow:0 0 10px rgba(0, 0, 0, 0.5);\n            display: block;\n            text-align: center;\n            //padding: 15px 30px;\n            margin: 0px 15px 10px 0px;\n            //border-radius: 2px 2px 2px 2px;\n            //min-width: 180px;\n            //margin: 0px 20px;\n            \n            .snapshot-card-top {\n                font-size: 0.8rem;\n                font-weight: 500;\n            }\n\n            .snapshot-highlight {\n                &.gray {\n                    border-bottom: 2px solid gray;\n                }\n\n                &.silver {\n                    border-bottom: 2px solid #C3CDE6;\n                }\n\n                &.gold {\n                    border-bottom: 2px solid gold;\n                }\n            }\n\n            .snapshot-card-center {\n                //display: none;\n                font-size: 1.5rem;\n                // font-size: 1.5rem;\n            }\n\n            .snapshot-card-bottom {\n                font-size: 14px\n            }\n\n            .snapshot-card-next {\n                font-size: 12px;\n                color: deepskyblue;\n            }\n\n        }\n    }\n}\n\n.score-metrix-title {\n    color: rgb(94, 108, 132);\n    font-weight: bold;\n}\n\n.score-metric-activity {\n    margin: 15px 0px 5px 0px;\n    font-size: 1.5rem;\n    text-align: center;\n    color: green;\n}\n\n.score-stat-container {\n    justify-content: space-between;\n    margin-top: 20px; \n}\n\n.snapshot-highlight {\n    &.gray {\n        border-bottom: 2px solid gray;\n    }\n\n    &.silver {\n        border-bottom: 2px solid #C3CDE6;\n    }\n\n    &.gold {\n        border-bottom: 2px solid gold;\n    }\n}\n\n//Start Jira Issues\n.css-1yjvs5a {\n    margin-bottom: 32px;\n}\n.css-1yq88hf {\n    table-layout: fixed;\n    width: 100%;\n    pointer-events: auto;\n    margin-top: 0px;\n}\ntable {\n    border-collapse: collapse;\n    width: 100%;\n}\nthead, tbody, tfoot {\n    border-bottom: 2px solid #dfe1e6;\n}\ntd, th {\n    text-align: left;\n    border: none;\n    padding: 4px 8px;\n}\n.inbound-header-referrer:first-of-type {\n    padding-left: 0px;\n}\ntd:first-child, th:first-child {\n    padding-left: 0;\n}\ntd:last-child, th:last-child {\n    padding-right: 0;\n}\n\n@mixin table-row-data {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    height: 40px;\n    box-sizing: border-box;\n    text-align: initial;\n    max-width: 0px;\n}\n\n.table-row-data {\n    @include table-row-data;\n}\n\n.inbound-header-referrer {\n    color: rgb(94, 108, 132);\n    vertical-align: middle;\n    text-align: initial;\n    padding: 4px 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.css-wwul1v {\n    color: rgb(94, 108, 132);\n    vertical-align: middle;\n    text-align: initial;\n    padding: 4px 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 104px;\n}\n.css-1v02n3u {\n    color: rgb(94, 108, 132);\n    vertical-align: middle;\n    text-align: initial;\n    padding: 4px 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.css-i7vie8 {\n    color: rgb(94, 108, 132);\n    vertical-align: middle;\n    text-align: center;\n    padding: 4px 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.css-jfpkqj {\n    background-color: initial;\n}\n.article-data-title {\n    @include table-row-data;\n}\n.article-data-trust {\n    @include table-row-data;\n    width: 104px;\n}\n.article-data-feedback{\n    @include table-row-data\n}\n.article-data-dismiss-menu {\n    @include table-row-data\n}\n.css-159i7d {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    height: 100%;\n}\n.css-bn30qb {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    overflow: hidden;\n    height: 100%;\n    padding-right: 4px;\n}\n.row-data-tag-container {\n    box-sizing: border-box;\n    appearance: none;\n    border: none;\n    display: inline-flex;\n    position: static;\n    padding-inline: var(--ds-space-050, 4px);\n    background-color: var(--ds-background-information, #DEEBFF);\n    border-radius: 3px;\n}\n.row-data-tag {\n    box-sizing: border-box;\n    margin: 0px;\n    padding: 0px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    color: var(--ds-text-information, #0052CC);\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 16px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-transform: uppercase;\n}\n.css-2iyn1h, .css-2iyn1h:hover, .css-2iyn1h:focus {\n    color: rgb(23, 43, 77);\n}\n.css-2iyn1h {\n    overflow: hidden;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n}\n.css-70qvj9 {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n}\n.css-1wm6frj {\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    //padding-right: 8px;\n    margin-right: 20px;\n}\n.css-i6bazn {\n    overflow: hidden;\n}\n.css-4y2086 {\n    overflow: hidden;\n    max-width: inherit;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.css-1nkownu {\n    padding-right: 8px;\n    color: rgb(107, 119, 140);\n    white-space: nowrap;\n}\n.css-7clv8h {\n    height: 32px;\n    width: 32px;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n    background-color: var(--ds-surface-overlay, #FFFFFF);\n    border-radius: 50%;\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0px);\n    transition: transform 200ms ease 0s, opacity 200ms ease 0s;\n    box-shadow: 0 0 0 2px var(--ds-surface-overlay, #FFFFFF);\n    border: none;\n    margin: 2px;\n    padding: var(--ds-scale-0, 0px);\n    font-size: inherit;\n    font-family: inherit;\n}\n.css-7clv8h::after {\n    background-color: transparent;\n    inset: 0px;\n    border-radius: 50%;\n    content: \" \";\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    transition: opacity 200ms ease 0s;\n    width: 100%;\n}\n.cLrmQm {\n    display: inline-flex;\n}\n.eteVrT {\n    display: inline-flex;\n    transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;\n}\n.css-fbv3aj, .css-fbv3aj:hover, .css-fbv3aj:active, .css-fbv3aj:focus, .css-fbv3aj:visited, .css-fbv3aj:disabled, .css-fbv3aj[disabled] {\n    -webkit-box-align: baseline;\n    align-items: baseline;\n    border-width: 0px;\n    border-radius: 3px;\n    box-sizing: border-box;\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    font-family: inherit;\n    font-weight: 500;\n    max-width: 100%;\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;\n    white-space: nowrap;\n    background: none;\n    cursor: pointer;\n    height: 2.28571em;\n    line-height: 2.28571em;\n    padding: 0px 2px;\n    vertical-align: middle;\n    width: auto;\n    -webkit-box-pack: center;\n    justify-content: center;\n    outline: none;\n    color: rgb(66, 82, 110) !important;\n}\n.css-1ujqpe8 {\n    transition: opacity 0.3s ease 0s;\n    opacity: 1;\n    align-self: center;\n    display: flex;\n    -webkit-box-flex: 0;\n    flex-grow: 0;\n    flex-shrink: 0;\n    line-height: 0;\n    font-size: 0px;\n    user-select: none;\n    margin: 0px 2px;\n}\n.css-snhnyn {\n    display: inline-block;\n    flex-shrink: 0;\n    line-height: 1;\n}\n.css-snhnyn > svg {\n    overflow: hidden;\n    pointer-events: none;\n    max-width: 100%;\n    max-height: 100%;\n    color: var(--icon-primary-color);\n    fill: var(--icon-secondary-color);\n    vertical-align: bottom;\n}\n\n.action-list-item-icon {\n    color: lightskyblue\n}","$gray: gray !default;\n$silver: #C3CDE6 !default;\n$gold: gold !default;\n$brown: brown !default;\n$andrena-blue: rgba(28, 129, 158, 0.8);\n$black: black !default;\n$lightgray: lightgray !default;\n$darkgray: darkgray !default;\n$white: white !default;\n\n.gray {\n    color: gray;\n}\n.silver {\n    color:#C3CDE6;\n}\n.gold {\n    color: gold;\n}\n.brown {\n    color: brown;\n}\n  ","@mixin fbox {\n    flex:1;\n    display: flex;\n}\n  \n@mixin vflex {\n    /* current syntax */\n    display: -webkit-flex;\n    display:    -moz-flex;\n    display:     -ms-flex;\n    display:         flex;\n\n    -webkit-flex-direction: column;\n        -moz-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n\n@mixin hflex {\n    /* current syntax */\n    display: -webkit-flex;\n    display:    -moz-flex;\n    display:     -ms-flex;\n    display:         flex;\n\n    -webkit-flex-direction: row;\n        -moz-flex-direction: row;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n\n@mixin overflow-hidden {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n@mixin shadow-gray {\n    box-shadow: 2px 2px 0px 0px $lightgray,\n}\n\n@mixin center-margin {\n    margin-right: auto;\n    margin-left: auto;\n}\n\n@mixin shadow1 {\n    box-shadow: 2px 2px 0px 0px $lightgray,\n        0px 0px 6px 0px $lightgray;\n}\n\n@mixin border1 {\n    border: 1px solid $lightgray;\n}\n\n@mixin rounded-border1 {\n    border: 1px solid $lightgray;\n    border-radius: 8px;\n}\n\n@mixin space-between {\n    /* previous syntax */\n    -webkit-box-pack: justify;\n    -moz-box-pack: justify;\n    -ms-box-pack: justify;\n        box-pack: justify;\n\n    /* current syntax */\n    -webkit-justify-content: space-between;\n    -moz-justify-content: space-between;\n    -ms-justify-content: space-between;\n        justify-content: space-between;\n}\n\n@mixin flex-left {\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n@mixin flex-right {\n    justify-self: flex-end;\n    margin-left: auto;\n}\n\n@mixin sunken {\n    box-shadow: \n        1px 3px 5px -1px rgb(0 0 0 / 20%) inset, \n        1px 6px 10px 0 rgb(0 0 0 / 14%) inset, \n        1px 1px 18px 0 rgb(0 0 0 / 12%) inset;\n}\n\n@mixin hive-splash1 {\n    content: \"\";\n    background-image: url(\"/assets/bg1.jpg\");\n    opacity: 1;\n    background-repeat: no-repeat;\n    background-size: cover; \n}\n\n.fbox {\n  flex:1;\n  display: flex;\n}\n\n.vflex {\n  /* current syntax */\n  display: -webkit-flex;\n  display:    -moz-flex;\n  display:     -ms-flex;\n  display:         flex;\n\n  -webkit-flex-direction: column;\n     -moz-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.hflex {\n  /* current syntax */\n  display: -webkit-flex;\n  display:    -moz-flex;\n  display:     -ms-flex;\n  display:         flex;\n\n  -webkit-flex-direction: row;\n     -moz-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n\n.flex-center {\n    //display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.shadow-gray {\n    border: 1px solid $lightgray;      \n    box-shadow: 2px 2px 5px 1px $lightgray;\n}\n\n.space-between {\n    /* previous syntax */\n    -webkit-box-pack: justify;\n        -moz-box-pack: justify;\n        -ms-box-pack: justify;\n            box-pack: justify;\n\n    /* current syntax */\n    -webkit-justify-content: space-between;\n        -moz-justify-content: space-between;\n        -ms-justify-content: space-between;\n            justify-content: space-between;\n}\n\n.flex-left {\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n.flex-right {\n    justify-self: flex-end;\n    margin-left: auto;\n}\n\n.right-margin-20 {\n    margin-right: 20px;\n}\n\n.left-margin-20 {\n    margin-left: 20px;\n}\n\n.bottom-margin-20 {\n    margin-bottom: 20px;\n}\n\n.bottom-margin-30 {\n    margin-bottom: 30px;\n}\n\n.bottom-margin-40 {\n    margin-bottom: 40px;\n}\n\n.top-margin-20 {\n    margin-top: 20px;\n}\n\n.top-margin-40 {\n    margin-top: 40px;\n}\n\n.margin-auto {\n    margin:auto\n}\n.h-margin-auto {\n    margin-right: auto;\n    margin-left: auto;\n}\n.v-margin-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.flex-30 {\n    flex: 0 0 30%;\n}\n\n.flex-90 {\n    flex: 0 0 90%;\n}\n\n.padding-right-10 {\n    padding-right: 10%;\n}","@import './colors.scss';\n@import './mixins.scss';\n\n// Styles for main view container\n.main {\n    /* previous syntax */\n    -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -ms-box-flex: 1;\n            box-flex: 1;\n\n    /* current syntax */\n    -webkit-flex: 1;\n        -moz-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    //padding: 10px;\n    //padding: 10px 6% 10px 6%;\n    overflow-y: auto;\n}\n\n.main-header-container {\n    //font-size: 20px;\n    margin-bottom: 20px;\n    // margin-top: 20px;\n    //font-family: 'Alice', serif;\n    @include hflex;\n    .main-header {\n        @include hflex;\n        flex-wrap: wrap;\n        .main-header-title {\n            font-size: 1.25rem;\n            flex-basis: 100%;\n            font-weight: 500;\n            //text-shadow: 2px 2px $lightgray;\n        }\n        .main-header-icon {\n            color: $andrena-blue;\n            font-size: 28px;\n            margin-right: 10px;\n            align-self: center;\n            text-shadow: 2px 2px $lightgray;\n        }\n    }\n}\n\n.main-aside-open {\n    padding-right: calc(320px + 0px);\n}\n\n.main-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    height: 100%;\n}\n\n.main-loading-container {\n    //Todo: add styling for loading \n}\n\n.sunken {\n    box-shadow: \n        1px 3px 5px -1px rgb(0 0 0 / 20%) inset, \n        1px 6px 10px 0 rgb(0 0 0 / 14%) inset, \n        1px 1px 18px 0 rgb(0 0 0 / 12%) inset;\n}\n","// button {\n//     background-color: inherit;\n// }\n\n// $table-cell-padding-y:        .5rem;\n// $table-cell-padding-x:        1.5rem;\n// $table-cell-padding-y-sm:     .25rem;\n// $table-cell-padding-x-sm:     .25rem;\n\n// modal overrides\n\n.modal-dialog.modal-fullscreen-url-viewer-down {\n    width: 90vw;\n    max-width: none;\n    height: 100%;\n    margin: auto;\n    padding-top: 30px;\n\n    .modal-body {\n      padding: 1rem;\n    }\n}\n\n.modal-dialog {\n  //max-width: 600px;\n  //margin: 8rem auto;\n}\n\n.suggestion-html-content > a {\n  color: #067272;\n  font-weight: 500;\n  cursor: auto;\n}\n\n\n// .modal-content {\n//   border-radius: 10px;\n//   padding: 1rem;\n// }\n\n@media (min-width: 800px)\n{\n  .modal-dialog {\n    max-width: fit-content;\n    //max-width: 600px;\n    //margin: 1.75rem auto;\n  }\n}\n\n.modal-body {\n  //padding: 2.4rem 2.4rem 2.4rem 2.4rem;\n  .h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n    margin-bottom: 1.25rem;\n    color: #022B2A;\n  }\n}\n\n\n\n// .myCustomModalClass {\n//     position: fixed;\n//     top: 20px;\n//     right: 20px;\n//     bottom: 20px;\n//     left: 20px;\n//     z-index: 1060;\n//     display: none;\n//     overflow: hidden;\n//     -webkit-overflow-scrolling: touch;\n//     outline: 0;\n// }\n\n// .modal.modal-fullscreen {\n//     /* Maximize the main wrappers on the screen */\n//     /* Make the parent wrapper of the modal box a full-width block */\n//     /* Remove borders and effects on the content */\n//     /**\n//        * /!\\ By using this feature, you force the header and footer to be placed\n//        * in an absolute position. You must handle by yourself the margin of the\n//        * content.\n//        */\n//   }\n//   .modal.modal-fullscreen .modal-dialog,\n//   .modal.modal-fullscreen .modal-content {\n//     bottom: 0;\n//     left: 0;\n//     position: absolute;\n//     right: 0;\n//     top: 0;\n//   }\n//   .modal.modal-fullscreen .modal-dialog {\n//     margin: 0;\n//     width: 100%;\n//     animation-duration:0.6s;\n//   }\n//   .modal.modal-fullscreen .modal-content {\n//     border: none;\n//     -moz-border-radius: 0;\n//     border-radius: 0;\n//     -webkit-box-shadow: inherit;\n//     -moz-box-shadow: inherit;\n//     -o-box-shadow: inherit;\n//     box-shadow: inherit;\n//     /* change bg color below */\n//    /* background:#1abc9c; */\n//   }\n//   .modal.modal-fullscreen.force-fullscreen {\n//     /* Remove the padding inside the body */\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-body {\n//     padding: 0;\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-header,\n//   .modal.modal-fullscreen.force-fullscreen .modal-footer {\n//     position: absolute;\n//     bottom: 0;\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-header {\n//     top: 0;\n//   }\n  \n  /* The styles above for the modal-body, footer, etc aren't being applied so I tried the ones below and they work */\n  .modal-body {\n    height: 100%;\n  }\n  \n  // .modal-footer {\n  //   width: 100%;\n  //   position: absolute;\n  //   bottom: 0;\n  //   background-color: #FFF;\n  // }\n  ","\n// Form styles\n.light-style__logo-container img {\n    width: 170px;\n    display: flex;\n    /* padding: 0px; */\n    align-items: center;\n    background: none;\n    border: 0px;\n    border-radius: 3px;\n    color: inherit;\n    cursor: pointer;\n    margin: 20px;\n}\n\n.light-style__floating-form-container {\n    width: 350px;\n    margin: 20px auto;\n    background-color: inherit;\n    border-radius: 15px;\n    padding: 4px;\n}\n\n.light-style__form-group {\n    margin-top: 20px;\n\n    label {\n        display: block;\n        margin-bottom: 10px;\n    }\n\n    input {\n        // width: 100%;\n        // padding: 10px;\n        // border-radius: 5px;\n        // border: 1px solid lightgray;\n        min-width: 0;\n        width: 100%;\n        height: 100%;\n        padding: 10px;\n        border: 1px solid #c4c7cf;\n        border-radius: 6px;\n        box-sizing: border-box;\n        color:  #191b23;\n        font-size: inherit;\n        text-overflow: ellipsis;\n        font-family: inherit;\n    }\n}\n\n.light-style__form-divider{\n    position: relative;\n    margin-top: 14px;\n    margin-bottom: 16px;\n    text-align: center;\n    border-top: 1px solid #d1d4db;\n    .divider-inner {\n        position: absolute;\n        top: -10px;\n        left: 0;\n        right: 0;\n        .divider-text {\n            background-color: #fff;\n            padding: 0 25px;\n            font-size: 14px;\n        }\n    }\n}\n\n// End Form styles\n\n// Link styles\n.light-style__quiet-link {\n    display: inline-block;\n    font-family: inherit;\n    color: #006dca;\n    line-height: normal;\n    position: relative;\n    cursor: pointer;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    box-shadow: none;\n    -webkit-tap-highlight-color: transparent;\n    outline: 0;\n    background: 0 0;\n    transition: color .15s ease-in-out;\n}\n\n// End Link styles\n\n// Button styles\n.light-style__button_form-submit {\n    background-color: rgba(205, 227, 227, 0.8);\n    width: 100%;\n    border: 0;\n    //border: 1px solid rgba(205, 227, 227, 0.8);\n    position: relative;\n    margin-bottom: 12px;\n    height: 40px;\n    border-radius: 6px;\n    font-size: 16px;\n}\n\n.light-style__button_third-party-auth {\n    background-color: #fff;\n    width: 100%;\n    border: 1px solid #c4c7cf;\n    position: relative;\n    margin-bottom: 12px;\n    height: 40px;\n    border-radius: 6px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 150%;\n\n    img {\n        margin-top: -4px;\n    }\n}\n\n.button_full-width {\n    width: 100%;\n}\n\n.light-style__cancel-button {\n    background-color: #fff;\n    border: 1px solid #022B2A;\n    color: #022B2A;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n}\n\n.light-style__confirm-button {\n    background-color: #022B2A;\n    border: 1px solid #022B2A;\n    color: #fff;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n}\n\n\n// End button styles\n\nmain.light-style__page-container{\n\n    padding: 20px 40px;\n    max-width: 1080px;\n\n    \n    h5, .h5 {\n        font-size: 1.625rem;\n    }\n    \n    .page-header {\n        margin: 0;\n    }\n    \n    section {\n        margin-bottom: 30px;\n    }\n\n    .section-discription {\n        font-size: 1em;\n        color: lightslategray;\n        margin-bottom: 20px;\n    }\n}\n\n.light-style__modal-container{\n    > * {\n        padding: 1rem 2rem;\n    }\n\n    h5, .h5 {\n        font-size: 1.625rem;\n    }\n\n    h6 {\n        color: #022B2A;\n        font-weight: bold;\n    }\n\n    .modal-header {\n        display: flex;\n        flex-direction: column;\n        align-items: normal;\n        border-bottom: 1px solid #E5E5E5;\n    }\n\n    .page-header {\n        margin: 0;\n    }\n    \n    section {\n        margin-bottom: 30px;\n    }\n\n    .section-discription {\n        font-size: 1em;\n        color: lightslategray;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
